import { render, staticRenderFns } from "./AddProductMenu.vue?vue&type=template&id=2269420a&"
import script from "./AddProductMenu.vue?vue&type=script&lang=js&"
export * from "./AddProductMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports